import { gql } from '@apollo/client';
import { DeveloperEmail } from '../profile-graphql';
import { mutate } from '../../../../../common/graphql';

export interface UpdateEmailPreferencesInput {
  gameFeedbackEmail: string;
  iapSupportEmail: string;
  hasOptedOutUserFeedbackEmail: boolean;
}

export interface UpdateEmailPreferencesMutation {
  developerUpdateEmailPreferences: {
    gameFeedbackEmail: DeveloperEmail;
    iapSupportEmail: DeveloperEmail;
  };
}

export const UPDATE_EMAIL_PREFERENCES_MUTATION = gql`
  mutation updateEmailPreferences($input: UpdateEmailPreferencesInput!) {
    developerUpdateEmailPreferences(input: $input) {
      gameFeedbackEmail {
        email
        isVerified
      }
      iapSupportEmail {
        email
        isVerified
      }
    }
  }
`;

export function updateEmailPreferences(input: UpdateEmailPreferencesInput) {
  return mutate<UpdateEmailPreferencesInput, UpdateEmailPreferencesMutation>(UPDATE_EMAIL_PREFERENCES_MUTATION, input);
}
